
import React, { useState } from "react";
import {
  Mail,
  Phone,
  Clock3,
  UsersRound,
  Award,
  ArrowLeftRight,
  ArrowRight,
  
} from "lucide-react";

import "./Contact.css";
// import { setMargin } from "recharts/types/state/layoutSlice";

const CONTACT_EMAIL = "support@certedtechnologies.com";

const teams = [
  {
    number: "01",
    icon: UsersRound,
    label: "FOR ORGANIZATIONS",
    title: "Hiring trainers",
    email: "hiring@example.com",
  },
  {
    number: "02",
    icon: Award,
    label: "FOR TRAINERS",
    title: "Joining CertED",
    email: "trainers@example.com",
  },
  {
    number: "03",
    icon: ArrowLeftRight,
    label: "SUPPORT",
    title: "Help and partnerships",
    email: "support@example.com",
  },
];

function Contact() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    enquiry: "Hire a trainer",
    message: "",
  });

  const [notice, setNotice] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setNotice("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (CONTACT_EMAIL === "your-email@example.com") {
      setNotice("Please configure your contact email first.");
      return;
    }

    const subject = encodeURIComponent(
      `CertED Enquiry: ${form.enquiry}`
    );

    const body = encodeURIComponent(
      `Name: ${form.name}\n` +
      `Phone: ${form.phone}\n` +
      `Email: ${form.email}\n` +
      `Enquiry: ${form.enquiry}\n\n` +
      `Message:\n${form.message}`
    );

    window.location.href =
      `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`;

    setNotice("Opening your email application...");
  };

  return (
    <main className="certed-contact">
      <div className="contact-container">

        {/* Contact Hero */}
        <section className="contact-hero">
          <div className="contact-intro">

            <div className="response-badge">
              <span className="status-dot" />
              We reply within one working day
            </div>

            <h1>
              Get in touch
              <br />
              with <span>CertED</span>
            </h1>

            <div className="gold-line" />

            <p className="intro-description">
              Looking to hire trainers, join as one, or just
              have a question? Tell us what you need and
              we'll point you to the right person.
            </p>

            <div className="contact-details">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="detail-card"
              >
                <div className="detail-icon">
                  <Mail size={19} />
                </div>

                <div>
                  <small>Email</small>
                  <strong>
                    {CONTACT_EMAIL === "support@certedtechnologies.com"
                      ? "support@certedtechnologies.com"
                      : "support@certedtechnologies.com"}
                  </strong>
                </div>
              </a>

              <div className="detail-card">
                <div className="detail-icon">
                  <Phone size={19} />
                </div>

                <div>
                  <small>Phone</small>
                  <strong>+91 9009015026</strong>
                </div>
              </div>

              <div className="detail-card">
                <div className="detail-icon">
                  <Clock3 size={19} />
                </div>

                <div>
                  <small>Hours</small>
                  <strong>MON–SAT, 9:30 AM – 6:30 PM</strong>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-card">
            <div className="form-top-border" />

            <span className="eyebrow">QUICK MESSAGE</span>
            <h2>Tell us what you need</h2>

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <label>
                  Full name *
                  <input
                    type="text"
                    name="name"
                    placeholder="Your name"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </label>

                <label>
                  Phone
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </label>
              </div>

              <label>
                Email *
                <input
                  type="email"
                  name="email"
                  placeholder="you@company.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                I'm here to
                <select
                  name="enquiry"
                  value={form.enquiry}
                  onChange={handleChange}
                >
                  <option>Hire a trainer</option>
                  <option>Join as a trainer</option>
                  <option>Ask for support</option>
                  <option>Discuss a partnership</option>
                  <option>Other enquiry</option>
                </select>
              </label>

              <label>
                Message *
                <textarea
                  name="message"
                  placeholder="Tell us what you need..."
                  value={form.message}
                  onChange={handleChange}
                  rows={5}
                  required
                />
              </label>

              <button type="submit" className="send-button">
                Send message <ArrowRight size={17} />
              </button>

              {notice && (
                <p className="form-notice" role="status">
                  {notice}
                </p>
              )}

              <p className="privacy-note">
                By sending, you agree we may contact you about
                your enquiry. We never share your details.
              </p>
            </form>
          </div>
        </section>

        {/* Contact Teams */}
        <section className="team-section">
          <span className="eyebrow">REACH THE RIGHT TEAM</span>

          <h2>
            Who should you <span>talk to?</span>
          </h2>

          <div className="team-grid">
            {teams.map((team) => {
              const Icon = team.icon;

              return (
                <article className="team-card" key={team.number}>
                  <div className="team-card-top">
                    <div className="detail-icon">
                      <Icon size={19} />
                    </div>

                    <span className="team-number">
                      {team.number}
                    </span>
                  </div>

                  <span className="team-eyebrow">
                    {team.label}
                  </span>

                  <h3>{team.title}</h3>

                  <a
                    className="team-email"
                    href={`mailto:${team.email}`}
                  >
                    {team.email}
                    <ArrowRight size={13} />
                  </a>
                </article>
              );
            })}
          </div>
        </section>

        {/* Office Location */}
       
{/* Office Location */}


<section className="visit-section">
  <div className="visit-content">
    <span className="eyebrow">VISIT US</span>
    <h2 className="">Come by the office.</h2>

     <div className="gold-line" />

    {/* Main Office - Gwalior */}
    <div className="office-location">
      <h3>Main Office</h3>
      <p>
        Abhilasha Bhavan, Bhind Road,
        <br />
        Pinto Park Tiraha,
        <br />
        Gwalior, Madhya Pradesh 474005
      </p>

      <div className="direction">
        <a
          href="https://www.google.com/maps/search/?api=1&query=CertED+Technologies%2C+Abhilasha+Bhavan%2C+Bhind+Road%2C+Pinto+Park+Tiraha%2C+Gwalior%2C+Madhya+Pradesh+474005"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get directions
        </a>
        <a
          className="dirright"
          href="https://www.google.com/maps/search/?api=1&query=CertED+Technologies%2C+Abhilasha+Bhavan%2C+Bhind+Road%2C+Pinto+Park+Tiraha%2C+Gwalior%2C+Madhya+Pradesh+474005"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Directions to main office"
        >
          <ArrowRight size={16} />
        </a>
      </div>
    </div>

    {/* Branch Office - Noida */}
    <div className="office-location">
      <h3>Branch Office – Noida</h3>
      <p>
        Sector 15,
        <br />
        Noida, Uttar Pradesh 201301
      </p>

      <div className="direction">
        <a
          href="https://www.google.com/maps/search/?api=1&query=Sector+15%2C+Noida%2C+Uttar+Pradesh+201301"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get directions
        </a>
        <a
          className="dirright"
          href="https://www.google.com/maps/search/?api=1&query=Sector+15%2C+Noida%2C+Uttar+Pradesh+201301"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Directions to Noida office"
        >
          <ArrowRight size={16} />
        </a>
      </div>
    </div>
  </div>

  {/* Office Maps */}
  <div className="map-embed">
    <iframe
      title="CertED Technologies Main Office - Gwalior"
      src="https://maps.google.com/maps?q=Abhilasha%20Bhavan%2C%20Bhind%20Road%2C%20Pinto%20Park%20Tiraha%2C%20Gwalior%2C%20Madhya%20Pradesh%20474005&output=embed"
      width="100%"
      height="280"
      style={{ border: 0 }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />

    <iframe
      title="CertED Technologies Branch Office - Noida"
      src="https://maps.google.com/maps?q=Sector%2015%2C%20Noida%2C%20Uttar%20Pradesh%20201301&output=embed"
      width="100%"
      height="280"
      style={{ border: 0 }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>
</section>


      </div>

    
    </main>
  );
}

export default Contact;
